import { ENVIRONMENTS } from '@belong/common';
import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';

const clientToken = process.env.NEXT_PUBLIC_DATADOG_APPLICATION_CLIENT_TOKEN;
const applicationId =
  process.env.NEXT_PUBLIC_DATADOG_APPLICATION_APPLICATION_ID;
const apiUrl = process.env.NEXT_PUBLIC_API_URL;
const env = process.env.NEXT_PUBLIC_ENV;

const isLocal = env === ENVIRONMENTS.DEVELOPMENT;
const isProduction = env === ENVIRONMENTS.PRODUCTION;

const RUM_SAMPLE_RATE = 10;
const LOGS_SAMPLE_RATE = 50;

export function initDataDog() {
  if (isLocal || !clientToken || !applicationId) {
    return;
  }

  if (isProduction) {
    datadogRum.init({
      clientToken,
      applicationId,
      site: 'datadoghq.com',
      service: 'belong-consumer',
      env,
      version: __BUILD_NUMBER__,
      sampleRate: RUM_SAMPLE_RATE,
      trackInteractions: true,
      premiumSampleRate: 0,
      allowedTracingOrigins: [apiUrl],
      silentMultipleInit: true,
    });

    datadogRum.stopSessionReplayRecording();
  }

  datadogLogs.init({
    clientToken,
    forwardErrorsToLogs: true,
    site: 'datadoghq.com',
    service: 'belong-consumer',
    env,
    version: __BUILD_NUMBER__,
    sampleRate: LOGS_SAMPLE_RATE,
    silentMultipleInit: true,
  });
}
